// @ts-nocheck
import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import styles from "./styles.css";

const Code = ({ className, children }) => <code className={cn(styles.code, className)}>{children}</code>;

Code.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default Code;
